var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLetter48Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5302 28.7698C45.9988 17.9836 39.256 7.23843 28.4698 4.76982C17.6836 2.3012 6.93844 9.04395 4.46982 19.8302C2.00121 30.6164 8.74396 41.3616 19.5302 43.8302C30.3164 46.2988 41.0616 39.556 43.5302 28.7698Z",
    fill: "#E4E7EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4 14H13.6C12.17 14 11.013 15.17 11.013 16.6L11 32.2C11 33.63 12.17 34.8 13.6 34.8H27.692C27.2502 33.9641 27 33.0113 27 32C27 28.6863 29.6863 26 33 26C34.5367 26 35.9385 26.5777 37 27.5278V16.6C37 15.17 35.83 14 34.4 14ZM33.88 19.525L24.689 25.271C24.273 25.531 23.727 25.531 23.311 25.271L14.12 19.525C13.9896 19.4518 13.8755 19.353 13.7845 19.2344C13.6934 19.1158 13.6274 18.98 13.5903 18.8352C13.5533 18.6904 13.5461 18.5395 13.569 18.3918C13.592 18.2441 13.6446 18.1026 13.7239 17.9758C13.8031 17.849 13.9072 17.7397 14.0299 17.6543C14.1527 17.5689 14.2914 17.5094 14.4378 17.4792C14.5843 17.449 14.7353 17.4489 14.8817 17.4787C15.0282 17.5086 15.1671 17.5679 15.29 17.653L24 23.1L32.71 17.653C32.8329 17.5679 32.9718 17.5086 33.1183 17.4787C33.2647 17.4489 33.4157 17.449 33.5622 17.4792C33.7086 17.5094 33.8473 17.5689 33.9701 17.6543C34.0928 17.7397 34.1969 17.849 34.2761 17.9758C34.3554 18.1026 34.408 18.2441 34.431 18.3918C34.4539 18.5395 34.4467 18.6904 34.4097 18.8352C34.3726 18.98 34.3066 19.1158 34.2155 19.2344C34.1245 19.353 34.0104 19.4518 33.88 19.525Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9407_15269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5 30.5L31.5 33.5M31.5 30.5L34.5 33.5",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9407_15269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(30 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter48Px);
export default __webpack_public_path__ + "static/media/letter_48px.51f62be017619240a5a8caf1b3b8f013.svg";
export { ForwardRef as ReactComponent };